export default {
      id: "icon-checkbox-usage",
      viewBox: "0 0 14 11",
      url: __webpack_public_path__ + "img/icons.50d286a4.svg#icon-checkbox",
      toString: function () {
        return this.url;
      }
    }